import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { B2BPlantNavService } from '../../plants/services/B2B-plant-nav.service';

@Component({
  selector: 'app-plant-list-table',
  imports: [MatButtonModule, MatCardModule, MatMenuModule, MatPaginatorModule, MatTableModule, MatCheckboxModule, MatTooltipModule],
  templateUrl: './plant-list-table.html',
  styleUrl: './plant-list-table.scss'
})
export class PlantListTable implements AfterViewInit {

    displayedColumns: string[] = ['snId', 'plantName', 'production', 'consumption', 'startupDate', 'batteryLevel', 'status']; // 'select' and 'action' can be added if needed
    dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
    selection = new SelectionModel<PeriodicElement>(true, []);

    @ViewChild(MatPaginator) paginator!: MatPaginator;

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }
    
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    toggleAllRows() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }
        this.selection.select(...this.dataSource.data);
    }
  
    /** The label for the checkbox on the passed row */
    checkboxLabel(row?: PeriodicElement): string {
        if (!row) {
            return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.snId}`;
    }
  
    // Search Filter
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  
    constructor( public themeService: CustomizerSettingsService, private b2bPlantNavService: B2BPlantNavService ) {}

    viewPlant(element: any) {
        this.b2bPlantNavService.goToPlantDetails(element.snId);
    }
}

const ELEMENT_DATA: PeriodicElement[] = [
    {
        snId: 'TPJ4CCU013',
        plantName: {
            name: 'TPJ4C',
            city: 'Aarhus'
        },
        production: 10.6,
        consumption: 19.2,
        startupDate: '2025-06-14',
        batteryLevel: '54 %',
        status: {
            online: 'Online',
            // abnormal: 'Abnormal',
            // offline: 'Offline',
        },
        action: {
            view: 'visibility'
        }
    },
    {
        snId: 'GZD191204F',
        plantName: {
            name: 'GZD19',
            city: 'Thisted'
        },
        production: 13.02,
        consumption: 32.04,
        startupDate: '2024-11-02',
        batteryLevel: '-', // or 'No batteri' ?
        status: {
            online: 'Online',
            // abnormal: 'Abnormal',
            // offline: 'Offline',
        },
        action: {
            view: 'visibility'
        }
    },
    {
        snId: 'HAD1850037',
        plantName: {
            name: 'HAD18',
            city: 'Roskilde'
        },
        production: 0.0,
        consumption: 25.6,
        startupDate: '2025-01-27',
        batteryLevel: '-', // or 'No batteri' ?
        status: {
            // online: 'Online',
            abnormal: 'Abnormal',
            // offline: 'Offline',
        },
        action: {
            view: 'visibility'
        }
    },
    {
        snId: 'LQD092103A',
        plantName: {
            name: 'LQD09',
            city: 'Odense'
        },
        production: 21.7,
        consumption: 29.51,
        startupDate: '2025-03-06',
        batteryLevel: '100 %',
        status: {
            online: 'Online',
            // abnormal: 'Abnormal',
            // offline: 'Offline',
        },
        action: {
            view: 'visibility'
        }
    },
    {
        snId: 'MDD0921101',
        plantName: {
            name: 'MDD09',
            city: 'Esbjerg'
        },
        production: 0.0,
        consumption: 21.2,
        startupDate: '2023-12-18',
        batteryLevel: '0 %',
        status: {
            // online: 'Online',
            // abnormal: 'Abnormal',
            offline: 'Offline',
        },
        action: {
            view: 'visibility'
        }
    },
];

export interface PeriodicElement {
    snId: string;
    plantName: any;
    production: number;
    consumption: number;
    batteryLevel: string;
    startupDate: string;
    status: any;
    action: any;
}